export const isName = (input: string) =>
  /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff- ',.0-9]*)$/g.test(input)
